import React, { useContext } from "react";
import styles from "./Footer.module.scss";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Context } from "../Store";
import CopiedContext from "../CopiedContext";
import BannerContainer from "../components/BannerContainer";
import { trackEvent } from "../utils/helpers";
import { isMobile } from "react-device-detect";
import { country } from "../utils/getStoriesAzureApi";

const Footer = (props) => {
  const state = React.useContext(Context);
  let country = state.country;
  let city = state.city;

  const SupportLinks = ({ cityurl }) => (
    <ol>
      <li>Support</li>
      <li>
        <a href={`https://${cityurl}/help`}>Help</a>
      </li>
      <li>
        <a href={`https://${cityurl}/contact`}>Contact Us</a>
      </li>
      <li>
        <a href={`https://${cityurl}/christmas`}>Christmas</a>
      </li>
      <li>
        <a href="https://gifts.electricshuffle.com" target="_blank">
          Gift Cards
        </a>
      </li>
      <li>
        <a href="https://red-engine.com/yellow-ball" target="_blank">
          Purpose
        </a>
      </li>
      <li>
        <a href={`https://${cityurl}/about-us`}>About Us</a>
      </li>
      <li>
        <a href="https://careers.electricshuffle.com" target="_blank">
          Careers
        </a>
      </li>
    </ol>
  );

  const LegalLinks = ({ cityurl }) => (
    <ol>
      <li>
        <a>Legal</a>
      </li>
      <li>
        <a href={`https://${cityurl}/cookie-policy`}>Cookie Policy</a>
      </li>
      <li>
        <a
          href={`https://${cityurl}/files/pdf/Electric-Shuffle-Modern-Slavery-Policy-June-2025.pdf`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Modern Slavery
        </a>
      </li>
      <li>
        <a href={`https://${cityurl}/terms-and-conditions`}>Terms & Conditions</a>
      </li>
      <li>
        <a href={`https://${cityurl}/privacy-policy`}>Privacy Policy</a>
      </li>
    </ol>
  );

  const SocialLinks = () => {
    // Default (UK/global) links
    let linkedin = "https://www.linkedin.com/company/electric-shuffle";
    let instagram = "https://www.instagram.com/electricshuffle/";
    let facebook = "https://www.facebook.com/ElectricShuffleLondon/";

    // Optional (only for UK)
    const youtube = "https://www.youtube.com/@electricshuffle6454";
    const tiktok = "https://www.tiktok.com/@electricshuffleuk";

    if (country?.toLowerCase() === "us") {
      // US-specific links
      linkedin = "https://www.linkedin.com/company/electric-shuffle-usa/about/";
      instagram = "https://www.instagram.com/electricshuffleusa/";

      // Choose Facebook link based on city
      switch (city?.toLowerCase()) {
        case "new york":
        case "nyc":
          facebook = "https://www.facebook.com/electricshufflenyc/";
          break;
        case "chicago":
          facebook = "https://www.facebook.com/electricshufflechicago/";
          break;
        case "dallas":
          facebook = "https://www.facebook.com/ElectricShuffleDallas/";
          break;
        case "austin":
          facebook = "https://www.facebook.com/ElectricShuffleAustin/";
          break;
        default:
          facebook = "https://www.facebook.com/electricshuffleusa/";
      }
    }

    return (
      <div className={styles.socials}>
        {/* <a href={linkedin} target="_blank" rel="noopener noreferrer">
          <img src="/img/es_icon_linked.svg" alt="LinkedIn" />
        </a> */}

        <a href={facebook} target="_blank" rel="noopener noreferrer">
          <img src="/img/es_icon_fb.svg" alt="Facebook" />
        </a>

        <a href={instagram} target="_blank" rel="noopener noreferrer">
          <img src="/img/es_icon_insta.svg" alt="Instagram" />
        </a>

        {/* Only show YouTube and TikTok for non-US (UK) */}
        {country?.toLowerCase() !== "us" && (
          <>
            <a href={youtube} target="_blank" rel="noopener noreferrer">
              <img src="/img/es_icon_youtube.svg" alt="YouTube" />
            </a>

            <a href={tiktok} target="_blank" rel="noopener noreferrer">
              <img src="/img/es_icon_tiktok.svg" alt="TikTok" />
            </a>
          </>
        )}
      </div>
    );
  };

  return (
    <footer className={styles.footer}>
      {/* ================= Desktop Footer ================= */}
      <section className={styles.desktop}>
        <div className={styles.desktopInner}>
          <div className={styles.left}>
            <img src="/img/es-logo-light.svg" alt="Electric Shuffle" className={styles.desktopLogo} />
            <SocialLinks />
          </div>

          <div className={styles.right}>
            <div className={styles.linksContainer}>
              <div className={styles.linkColumn}>
                <SupportLinks cityurl={state.cityurl} />
              </div>
              <div className={styles.linkColumn}>
                <LegalLinks cityurl={state.cityurl} />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.copyright}>
            ELECTRIC SHUFFLE® is a registered trademark of Electric Shuffle IP Limited.
          </div>
          <div className={styles.sisterBrand}>
            <span>From the team behind</span>
            <a href="https://flightclubdarts.com" target="_blank" rel="noopener noreferrer">
              <img src="/img/fc-logo.svg" alt="Flight Club Darts" className={styles.flightClubLogo} />
            </a>
          </div>
        </div>
      </section>

      {/* ================= Mobile Footer ================= */}
      <section className={styles.mobile}>
        <div className={styles.mobileInner}>
          <img src="/img/es-logo-light.svg" alt="Electric Shuffle" className={styles.mobileLogo} />
          <SocialLinks />
          <div className={styles.mobileLinks}>
            <SupportLinks cityurl={state.cityurl} />
            <LegalLinks cityurl={state.cityurl} />
          </div>
          <div className={styles.copyright}>
            ELECTRIC SHUFFLE® is a registered
            <br />
            trademark of Electric Shuffle IP Limited.
          </div>
          <div className={styles.sisterBrand}>
            <span>From the team behind</span>
            <a href="https://flightclubdarts.com" target="_blank" rel="noopener noreferrer">
              <img src="/img/fc-logo.svg" alt="Flight Club Darts" className={styles.flightClubLogo} />
            </a>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
